import React from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useState } from "react";

const Layout = styled.div`
	height: 100%;
	width: 100%;
	font-family: "Roboto", sans-serif;
	display: flex;
	flex-direction: column;
`;

const Content = styled.div`
	position: relative;
	width: 100%;
	overflow-y: auto;
	height: 100%;
`;

const Div = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`;

const MachineLayout = (props) => {
	//Adding machinePage prop to header to add sidebar toggle on mobile devices

	//TODO: RnD on why CSSTransition renders the outlet twice even after giving it the location key

	const [showSidebar, toggle] = useState(true);

	return (
		<Layout>
			<Header machinePage showSidebar={showSidebar} toggle={toggle} />
			<Div>
				<Sidebar showSidebar={showSidebar} toggle={toggle} />
				<Content>{props.children}</Content>
			</Div>
		</Layout>
	);
};

export default MachineLayout;
